import { render, staticRenderFns } from "./WaitActivate.vue?vue&type=template&id=609fd696&"
import script from "./WaitActivate.vue?vue&type=script&lang=js&"
export * from "./WaitActivate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports